export const featureFlags = [
    'paymentTab',
    'publishersOnboarding',
    'reportsScheduling',
    'surveyPopup',
    'videoLimitations',
    'videoLimitationDuration',
    'videoLimitationSkippable',
    'widgetLibrary',
    'placementGroupTagTypes',
    'isVideoOrientationEnabled',
    'placementGroupOneOff',
    'sqlReportEditor',
    'isPlacementGroupThrottelingOn',
    'useMFAInUdrive'
];
